export interface TaxCategory {
  id: string;
  name: string;
  description?: string;
}

export const US_FEDERAL_TAX_CATEGORIES: TaxCategory[] = [
  {
    id: "advertising",
    name: "Advertising",
    description: "Costs for promoting your business",
  },
  {
    id: "car_truck",
    name: "Car and Truck Expenses",
    description: "Vehicle-related costs for business use",
  },
  {
    id: "commissions",
    name: "Commissions and Fees",
    description: "Payments to non-employees for services",
  },
  {
    id: "contract_labor",
    name: "Contract Labor",
    description: "Payments to independent contractors",
  },
  {
    id: "depreciation",
    name: "Depreciation",
    description: "Allocation of asset costs over time",
  },
  {
    id: "employee_benefits",
    name: "Employee Benefit Programs",
    description: "Costs for employee benefits",
  },
  {
    id: "insurance",
    name: "Insurance",
    description: "Premiums for business insurance policies",
  },
  {
    id: "interest",
    name: "Interest",
    description: "Interest paid on business loans",
  },
  {
    id: "legal_professional",
    name: "Legal and Professional Services",
    description: "Fees for legal and professional services",
  },
  {
    id: "office_expense",
    name: "Office Expenses",
    description: "Costs for office supplies and postage",
  },
  {
    id: "rent_lease",
    name: "Rent or Lease",
    description: "Payments for property or equipment rental",
  },
  {
    id: "repairs_maintenance",
    name: "Repairs and Maintenance",
    description: "Costs to maintain business property",
  },
  {
    id: "supplies",
    name: "Supplies",
    description: "Costs of items used in business operations",
  },
  {
    id: "taxes_licenses",
    name: "Taxes and Licenses",
    description: "Business-related taxes and licenses",
  },
  {
    id: "travel",
    name: "Travel",
    description: "Travel expenses for business purposes",
  },
  {
    id: "meals",
    name: "Meals",
    description: "Meal expenses related to business activities",
  },
  {
    id: "transfer",
    name: "Transfer",
    description: "Transfers between business accounts",
  },
  {
    id: "utilities",
    name: "Utilities",
    description: "Utility costs for business operations",
  },
  {
    id: "owner_draw",
    name: "Owner Draw",
    description: "Owner draws or distributions",
  },
  { id: "wages", name: "Wages", description: "Employee salaries and wages" },
  {
    id: "other_expenses",
    name: "Other Expenses",
    description: "Miscellaneous business expenses",
  },
];

export const OREGON_STATE_TAX_CATEGORIES: TaxCategory[] = [
  {
    id: "advertising",
    name: "Advertising",
    description: "Costs for promoting your business",
  },
  {
    id: "car_truck_expenses",
    name: "Car and Truck Expenses",
    description: "Vehicle-related costs for business use",
  },
  {
    id: "commissions_fees",
    name: "Commissions and Fees",
    description: "Payments to non-employees for services",
  },
  {
    id: "contract_labor",
    name: "Contract Labor",
    description: "Payments to independent contractors",
  },
  {
    id: "depreciation",
    name: "Depreciation",
    description: "Allocation of asset costs over time",
  },
  {
    id: "employee_benefit_programs",
    name: "Employee Benefit Programs",
    description: "Costs for employee benefits",
  },
  {
    id: "insurance",
    name: "Insurance",
    description: "Premiums for business insurance policies",
  },
  {
    id: "interest",
    name: "Interest",
    description: "Interest paid on business loans",
  },
  {
    id: "legal_professional_services",
    name: "Legal and Professional Services",
    description: "Fees for legal and professional services",
  },
  {
    id: "office_expenses",
    name: "Office Expenses",
    description: "Costs for office supplies and postage",
  },
  {
    id: "rent_lease",
    name: "Rent or Lease",
    description: "Payments for property or equipment rental",
  },
  {
    id: "repairs_maintenance",
    name: "Repairs and Maintenance",
    description: "Costs to maintain business property",
  },
  {
    id: "supplies",
    name: "Supplies",
    description: "Costs of items used in business operations",
  },
  {
    id: "taxes_licenses",
    name: "Taxes and Licenses",
    description: "Business-related taxes and licenses",
  },
  {
    id: "travel",
    name: "Travel",
    description: "Travel expenses for business purposes",
  },
  {
    id: "meals",
    name: "Meals",
    description: "Meal expenses related to business activities",
  },
  {
    id: "transfer",
    name: "Transfer",
    description: "Transfers between business accounts",
  },
  {
    id: "utilities",
    name: "Utilities",
    description: "Utility costs for business operations",
  },
  {
    id: "owner_draw",
    name: "Owner Draw",
    description: "Owner draws or distributions",
  },
  { id: "wages", name: "Wages", description: "Employee salaries and wages" },
  {
    id: "other_expenses",
    name: "Other Expenses",
    description: "Miscellaneous business expenses",
  },
];

export const TAX_CATEGORIES = {
  federal: US_FEDERAL_TAX_CATEGORIES,
  oregon: OREGON_STATE_TAX_CATEGORIES,
};
